import { ReactComponent as CabinetBoxOn } from "./icon/on_light_box.svg";
import { ReactComponent as CabinetBoxError } from "./icon/error_light_box.svg";
import { ReactComponent as CabinetBoxNormal } from "./icon/normal_light_box.svg";
import { eDeviceState } from "../../../common/constants";
import { ICabinetInfo } from ".";

interface ICabinetMarkerProps {
  id: number;
  cabinet: ICabinetInfo;
  handleClick: (cabinet: ICabinetInfo) => void;
  zoom: number;
}

const CabinetMarker = ({
  id,
  cabinet,
  handleClick,
  zoom,
  ...props
}: ICabinetMarkerProps) => {
  const renderIcon = (state: eDeviceState) => {
    switch (state) {
      case eDeviceState.ERROR:
        return <CabinetBoxError />;
      case eDeviceState.NORMAL:
        return <CabinetBoxNormal />;
      case eDeviceState.LIGHT_ON:
        return <CabinetBoxOn />;
    }
  };
  return (
    <div
      className="flex flex-col items-center justify-center relative cursor-pointer"
      title={`Tủ ${cabinet.identifier} - ${cabinet.name}`}
      onClick={() => handleClick(cabinet)}
    >
      <div className="text-sm relative font-medium text-[#964F19] whitespace-nowrap bg-neutral-White">
        {cabinet.name}
      </div>
      {renderIcon(cabinet.currentState)}
      {zoom > 17 && <div className="text-xs relative font-medium text-[#964F19] whitespace-nowrap bg-neutral-White">
        {cabinet.identifier}
      </div>}
    </div>
  );
};
export default CabinetMarker;
